var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPluginDayLengthIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M4.812 17a7.893 7.893 0 0 0 0 2.001L0 19v-2h4.812zm-.59-8.192 3.396 3.396a7.721 7.721 0 0 0-1.414 1.414l-3.396-3.396 1.414-1.414zM13 6v4.812a7.893 7.893 0 0 0-2 0V6h2zm6.778 2.808 1.414 1.414-3.396 3.396a7.721 7.721 0 0 0-1.415-1.414l3.397-3.396zM24 17v2l-4.812.001a7.895 7.895 0 0 0 0-2L24 17zm-12-5c1.667 0 3.083.583 4.25 1.75C17.417 14.917 18 16.333 18 18c0 .344-.025.678-.075 1H6.075A6.562 6.562 0 0 1 6 18c0-1.667.583-3.083 1.75-4.25C8.917 12.583 10.333 12 12 12z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F7F700",
  fillRule: "evenodd",
  d: "M12 14c1.1 0 2.042.392 2.825 1.175C15.608 15.958 16 16.9 16 18c0 .35-.04.683-.119 1H8.12A4.126 4.126 0 0 1 8 18c0-1.1.392-2.042 1.175-2.825C9.958 14.392 10.9 14 12 14z"
}))));
export default SvgPluginDayLengthIcon;